<template>
  <div
    class="org-admin-users_oau org-admin-input_oai"
    :class="{ [curTheme]: true }">
    <div class="oaf_label">Выберите пользователя</div>
    <el-select
      v-model="userIdsLoc"
      multiple
      filterable
      remote
      reserve-keyword
      clearable
      :remote-method="fetchUsersData"
      :loading="loading"
      @change="onChange"
      no-match-text="Нет подходящих данных."
      no-data-text="Нет данных."
      loading-text="Загрузка..."
      placeholder="Введите Ф.И.О...">
      <el-option
        v-for="(user, i) in users"
        :key="`opt-${i}`"
        :label="user.fio"
        :value="user.UserId">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import axios from 'axios';

export default {

  props: ['userIds'],

  data() {
    return {
      userIdsLoc: this.userIds,
      users: [],
      loading: false,
      reqTimer: null,
      reqDelay: 1500,
      queryMinLength: 3,
    };
  },

  watch: {
    userIds() {
      this.userIdsLoc = this.userIds;
    },
  },

  methods: {

    onChange() {
      this.$emit('update:userIds', this.userIdsLoc);
    },

    fetchUsersData(query) {
      if (query.length >= this.queryMinLength) {
        clearInterval(this.reqTimer);
        this.reqTimer = setTimeout(() => {
          this.loading = true;
          axios.get(`users/search?fio=${query}`).then((r) => {
            this.loading = false;
            const adminOrgId = this.$route.params.orgId;
            this.users = [];
            r.data.Users.forEach((user) => {
              if (user.Jobs) {
                const userOrg = user.Jobs.find(job => job.OrganizationId === adminOrgId);
                if (userOrg) {
                  let fio = user.Surname ? user.Surname : '';
                  fio += user.Name ? ` ${user.Name}` : '';
                  fio += user.Patronymic ? ` ${user.Patronymic}` : '';
                  this.users.push({ UserId: user.UserId, fio });
                }
              }
            });
          }).catch(() => {
            this.loading = false;
            this.$notify.error('Ошибка при получения данных объектов.');
          });
        }, this.reqDelay);
      } else {
        this.users = [];
      }
    },

  },

};
</script>

<style lang="scss">
@import '../../../styles/common/main';

.org-admin-obj-types_oap {
}
</style>



// WEBPACK FOOTER //
// src/components/org-admin/inputs/OrgAdminUsers.vue